module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_01-e28efcde3540a9b85c11c883c0fe83be.jpg";